import { useNavigate, useLocation } from "react-router-dom";
import { Heart, MessageCircle, User, Search } from "lucide-react";
import { useTranslation } from "../contexts/LanguageContext";
import { useUnread, CountBadge } from "./RealtimeNotifier";

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const unread = useUnread();
  const badges = { "/matches": unread.messages, "/who-liked-me": unread.likes };

  const navItems = [
    { path: "/discover", icon: Search, labelKey: "nav.discover" },
    { path: "/matches", icon: MessageCircle, labelKey: "nav.messages" },
    { path: "/who-liked-me", icon: Heart, labelKey: "nav.likes" },
    { path: "/profile", icon: User, labelKey: "nav.profile" }
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 h-16 sm:h-20 bg-black/80 backdrop-blur-xl border-t border-white/10 flex justify-around items-center z-50 px-safe" style={{ paddingBottom: 'max(0.5rem, env(safe-area-inset-bottom))' }} data-testid="bottom-nav">
      {navItems.map((item) => {
        const isActive = location.pathname === item.path || 
                        (item.path === "/discover" && location.pathname === "/discover");
        const Icon = item.icon;
        
        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`flex flex-col items-center gap-0.5 sm:gap-1 px-3 sm:px-4 py-1.5 sm:py-2 rounded-xl transition-all touch-target tap-highlight-none ${
              isActive ? "text-primary" : "text-muted-foreground hover:text-white"
            }`}
            data-testid={`nav-${item.labelKey.split('.')[1]}`}
          >
            <span className="relative">
              <Icon 
                className={`w-5 h-5 sm:w-6 sm:h-6 ${isActive ? "fill-current" : ""}`} 
                strokeWidth={isActive ? 2.5 : 2}
              />
              <CountBadge count={badges[item.path]} testId={`nav-badge-${item.labelKey.split('.')[1]}`} />
            </span>
            <span className="text-[10px] sm:text-xs font-medium">{t(item.labelKey)}</span>
          </button>
        );
      })}
    </nav>
  );
}
